import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import useUserStore from './stores/Users';

// Component
import Header from './components/Header';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import LoadingView from './components/Loading';

// Pages Home
import Home from './pages/home/Home';

// Auth
import Login from './pages/auth/Login';
import Profile from './pages/auth/Profile';
import ForgetPassword from './pages/auth/ForgetPassword';
import ResetPassword from './pages/auth/ResetPassword';

// Tabungan
import PengajuanTabungan from './pages/tabungan/PengajuanTabungan';
import Mutasi from './pages/tabungan/Mutasi';
import Tabunganku from './pages/tabungan/Tabunganku';

// Pinjaman Tunai
import PengajuanPinjam from './pages/pinjaman/PengajuanPinjam';
import MutasiPinjaman from './pages/pinjaman/MutasiPinjaman';
import StatusPinjaman from './pages/pinjaman/StatusPinjaman';
import PelunasanPinjaman from './pages/pinjaman/PelunasanPinjaman';

// Pinjaman Barang
import PengajuanPinjamBarang from './pages/pinjaman/PengajuanPinjamBarang';
import MutasiPinjamanBarang from './pages/pinjaman/MutasiPinjamanBarang';
import StatusPembelianBarang from './pages/pinjaman/StatusPembelianBarang';
import PelunasanPinjamanBarang from './pages/pinjaman/PelunasanPinjamanBarang';

// Anggota
import TambahAnggota from './pages/anggota/TambahAnggota';
import EditAnggota from './pages/anggota/EditAnggota';
import ListAnggota from './pages/anggota/ListAnggota';

// Setting
import IdentitasKoperasi from './pages/setting/IdentitasKoperasi';
import SettingBiaya from './pages/setting/SettingBiaya';
import TambahBiaya from './pages/setting/TambahBiaya';
import EditSettingBiaya from './pages/setting/EditSettingBiaya';
import SettingDate from './pages/setting/SettingDate';
import TambahDate from './pages/setting/TambahDate';
import EditSettingDate from './pages/setting/EditSettingDate';

// USP - Data Pinjaman Anggota
import ListPengajuanPinjamanTunai from './pages/pinjaman/ListPengajuanPinjamanTunai';
import ListPelunasanPinjamanTunai from './pages/pinjaman/ListPelunasanPinjamanTunai';
import ApprovalAjuanPinjamTunai from './pages/pinjaman/ApprovalAjuanPinjamTunai';
import ApprovalPelunasanPinjamTunai from './pages/pinjaman/ApprovalPelunasanPinjamTunai';
import DataPinjamanTunai from './pages/pinjaman/DataPinjamanTunai';
import EditPinjamanTunai from './pages/pinjaman/EditPinjamanTunai';
import ListPengajuanPinjamanBarang from './pages/pinjaman/ListPengajuanPinjamanBarang';
import ListPelunasanPinjamanBarang from './pages/pinjaman/ListPelunasanPinjamanBarang';
import ApprovalAjuanPinjamBarang from './pages/pinjaman/ApprovalAjuanPinjamBarang';
import ApprovalPelunasanPinjamBarang from './pages/pinjaman/ApprovalPelunasanPinjamBarang';
import DataPinjamanBarang from './pages/pinjaman/DataPinjamanBarang';
import EditPinjamanBarang from './pages/pinjaman/EditPinjamanBarang';

// USP - Data Tabungan Anggota
import ListPengajuanTabungan from './pages/tabungan/ListPengajuanTabungan';
import ApprovalAjuanTabung from './pages/tabungan/ApprovalAjuanTabung';
import ListTabungan from './pages/tabungan/ListTabungan';
import EditTabungan from './pages/tabungan/EditTabungan';

// BENDAHARA - Tagihan
import IuranWajib from './pages/tagihan/IuranWajib';
import IuranSPN from './pages/tagihan/IuranSPN';
import SimpananPokok from './pages/tagihan/SimpananPokok';
import TagihanTabungan from './pages/tagihan/TagihanTabungan';
import TagihanPinjamTunai from './pages/tagihan/TagihanPinjamTunai';
import TagihanPinjamBarang from './pages/tagihan/TagihanPinjamBarang';

// BENDAHARA - KAS
import MutasiKas from './pages/kas/MutasiKas';
import AddKas from './pages/kas/AddKas';
import Invoice from './pages/kas/Invoice';
// import RiwayatInvoice from './pages/kas/RiwayatInvoice';

// BROADCAST
import Broadcast from './pages/broadcast/Broadcast';
import ShowBroadcast from './pages/broadcast/ShowBroadcast';
import BroadcastList from './pages/broadcast/BroadcastList';


function App() {

  // roles
  const ADMIN = 1;
  const ANGGOTA = 2;
  const loading = JSON.parse(useUserStore((state) => state.loading));
  const token = useUserStore((state) => state.token);
  const users = useUserStore((state) => state.user);
  const refreshSession = useUserStore((state) => state.refreshSession);
  let dataShow;

  // refresh
  useEffect(() => {
    refreshSession();
  }, [refreshSession]);

  const hasAuthView = () => (
    <div className='page'>
      {/* <Header /> */}
      <Navbar />
      <div className='content'>
        <ScrollToTop />
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>

            {/* Profile & Reset Password */}
            <Route exact path="/auth/profile">
              <Profile />
            </Route>
            <Route exact path="/auth/resetpassword">
              <ResetPassword />
            </Route>

            {/* Anggota */}
            <Route exact path="/anggota/tambahanggota">
              <TambahAnggota />
            </Route>
            <Route exact path="/anggota/listanggota/editanggota/:id/:npp">
              <EditAnggota />
            </Route>
            <Route exact path="/anggota/listanggota">
              <ListAnggota />
            </Route>

            {/* Identitas Kopkar & Setting */}
            <Route exact path="/setting/identitaskoperasi">
              <IdentitasKoperasi />
            </Route>
            <Route exact path="/setting/settingbiaya">
              <SettingBiaya />
            </Route>
            <Route exact path="/setting/settingbiaya/tambahbiaya">
              <TambahBiaya />
            </Route>
            <Route exact path="/setting/settingbiaya/editsettingbiaya/:id">
              <EditSettingBiaya />
            </Route>
            <Route exact path="/setting/settingdate">
              <SettingDate />
            </Route>
            <Route exact path="/setting/settingdate/tambahdate">
              <TambahDate />
            </Route>
            <Route exact path="/setting/settingdate/editsettingdate/:id">
              <EditSettingDate />
            </Route>

            {/* Tabungan - Anggota */}
            <Route exact path="/tabungan/pengajuan">
              <PengajuanTabungan />
            </Route>
            <Route exact path="/tabungan/mutasi">
              <Mutasi />
            </Route>
            <Route exact path="/tabungan/tabunganku">
              <Tabunganku />
            </Route>

            {/* Pinjaman Tunai - Anggota */}
            <Route exact path="/tunai/pengajuanpinjam">
              <PengajuanPinjam />
            </Route>
            <Route exact path="/tunai/statuspinjaman">
              <StatusPinjaman />
            </Route>
            <Route exact path="/tunai/mutasipinjaman">
              <MutasiPinjaman />
            </Route>
            <Route exact path="/tunai/pelunasanpinjaman">
              <PelunasanPinjaman />
            </Route>

            {/* Pinjaman Barang - Anggota */}
            <Route exact path="/barang/pengajuanpinjambarang">
              <PengajuanPinjamBarang />
            </Route>
            <Route exact path="/barang/mutasipinjamanbarang">
              <MutasiPinjamanBarang />
            </Route>
            <Route exact path="/barang/statusbelibarang">
              <StatusPembelianBarang />
            </Route>
            <Route exact path="/barang/pelunasanpinjamanbarang">
              <PelunasanPinjamanBarang />
            </Route>

            {/* Data, Action, List Pinjaman Tunai - USP & Bendahara */}
            <Route exact path="/pinjamtunai/listpengajuanpinjamtunai">
              <ListPengajuanPinjamanTunai />
            </Route>
            <Route exact path="/pinjamtunai/listpelunasanpinjamtunai">
              <ListPelunasanPinjamanTunai />
            </Route>
            <Route exact path="/pinjamtunai/listpengajuanpinjamtunai/approvalajuanpinjam/:id/:iduser">
              <ApprovalAjuanPinjamTunai />
            </Route>
            <Route exact path="/pinjamtunai/listpelunasanpinjamtunai/approvalpelunasanpinjam/:id/:iduser">
              <ApprovalPelunasanPinjamTunai />
            </Route>
            <Route exact path="/pinjamtunai/datapinjamantunai">
              <DataPinjamanTunai />
            </Route>
            <Route exact path="/pinjamtunai/datapinjamantunai/editpinjamtunai/:id/:iduser">
              <EditPinjamanTunai />
            </Route>

            {/* Data, Action, List Pinjaman Barang - Pembiayaan & Bendahara */}
            <Route exact path="/pinjambarang/listpengajuanpinjambarang">
              <ListPengajuanPinjamanBarang />
            </Route>
            <Route exact path="/pinjambarang/listpelunasanpinjambarang">
              <ListPelunasanPinjamanBarang />
            </Route>
            <Route exact path="/pinjambarang/listpengajuanpinjambarang/approvalajuanpinjambarang/:id/:iduser">
              <ApprovalAjuanPinjamBarang />
            </Route>
            <Route exact path="/pinjambarang/listpelunasanpinjambarang/approvalpelunasanbarang/:id/:iduser">
              <ApprovalPelunasanPinjamBarang />
            </Route>
            <Route exact path="/pinjambarang/datapinjamanbarang">
              <DataPinjamanBarang />
            </Route>
            <Route exact path="/pinjambarang/datapinjamanbarang/editpinjambarang/:id/:iduser">
              <EditPinjamanBarang />
            </Route>

            {/* Data, Action, List Tabungan Berjangka - USP */}
            <Route exact path="/datatabungan/listtabungan">
              <ListTabungan />
            </Route>
            <Route exact path="/datatabungan/listtabungan/edittabungan/:id/:iduser">
              <EditTabungan />
            </Route>
            <Route exact path="/datatabungan/listpengajuantabungan">
              <ListPengajuanTabungan />
            </Route>
            <Route exact path="/datatabungan/listpengajuantabungan/approvalajuantabung/:id/:iduser">
              <ApprovalAjuanTabung />
            </Route>

            {/* Data, Action, List Tagihan - Bendahara */}
            <Route exact path="/tagihan/iuranwajib">
              <IuranWajib />
            </Route>
            <Route exact path="/tagihan/iuranspn">
              <IuranSPN />
            </Route>
            <Route exact path="/tagihan/simpananpokok">
              <SimpananPokok />
            </Route>
            <Route exact path="/tagihan/tabungan">
              <TagihanTabungan />
            </Route>
            <Route exact path="/tagihan/pinjamtunai">
              <TagihanPinjamTunai />
            </Route>
            <Route exact path="/tagihan/pinjambarang">
              <TagihanPinjamBarang />
            </Route>

            {/* Data, Action, Kas - Bendahara */}
            <Route exact path="/kas/mutasikas">
              <MutasiKas />
            </Route>
            <Route exact path="/kas/addkas">
              <AddKas />
            </Route>
            <Route exact path="/kas/invoice">
              <Invoice />
            </Route>
            {/* <Route exact path="/kas/riwayatinvoice">
              <RiwayatInvoice />
            </Route> */}

            {/* Notifikasi - USP, Pembiayaan, Bendahara, dan Admin */}
            <Route exact path="/broadcast">
              <Broadcast />
            </Route>
            <Route exact path="/broadcast/:notifId">
              <ShowBroadcast />
            </Route>
            <Route exact path="/broadcastlist">
              <BroadcastList />
            </Route>
            
          </Switch>
      </div>
    </div>
  )

  const authView = () => (
    // <div className='container'>
        <Switch>
          <Route exact path="/">
            <Header />
            <Login />
          </Route>
          <Route exact path="/auth/forgetpassword">
            <Header />
            <ForgetPassword />
          </Route>
          <Redirect to="/" />
        </Switch>
    // </div>
  );

  if (loading) {
    dataShow = <LoadingView />;
  } else if (token) {
    dataShow = hasAuthView();
  } else {
    dataShow = authView();
  }
  
  return dataShow;

}

export default App;
